import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { useQueryParam } from "~/common/hooks/useQueryParams";
import {
  documentListItem,
  documentListItemLabel,
  documentListPanel,
} from "./styles_vanilla.css";

export const DocumentList = ({
  documents,
}: {
  documents: Array<{ id: number; name: string; s3Link: string; profileId: number | null }>;
}) => {
  const [docId, setDocId] = useQueryParam("documentId");
  const selectedDocumentId = docId ? parseInt(docId) : 0;

  const viewDocument = (documentId: number) => {
    setDocId(String(documentId));
  };

  return (
    <div className={documentListPanel}>
      {documents.map((doc) => {
        return (
          <Flex
            className={documentListItem}
            key={doc.s3Link}
            data-selected={selectedDocumentId === doc.id}
            data-testid={`document-list-item-${doc.id}`}
            onClick={() => viewDocument(doc.id)}
          >
            <Icon
              type={doc.profileId ? "check" : "circle"}
              variant="outline"
              color={Colors.Neutral700}
            />
            <Text className={documentListItemLabel}>{doc.name}</Text>
          </Flex>
        );
      })}
    </div>
  );
};
